import { COLOR_CLASSES } from "@/reports/shared_utils/colorSystem";

/**
 * Pill-button option selector.
 *
 * Props:
 *   value     - currently selected value
 *   onChange  - called with the new value when a pill is clicked
 *   options   - Array<{ value: string, label: string }>
 *               An option with value="" is rendered as a clear (×) button
 *   colorMap  - maps option values to COLOR_CLASSES keys (e.g. { E: "emerald" })
 *   size      - "md" (default, text-sm font-medium gap-2)
 *             | "sm" (text-xs font-semibold gap-1.5)
 */
export function PillSelector({ value, onChange, options, colorMap = {}, size = "md" }) {
  const gapClass  = size === "sm" ? "gap-1.5" : "gap-2";
  const textClass = size === "sm" ? "text-xs font-semibold" : "text-sm font-medium";

  return (
    <div className={`flex flex-wrap ${gapClass}`}>
      {options.map((opt) => {
        const isClear    = opt.value === "";
        const colorName  = isClear ? "slate" : (colorMap[opt.value] || "slate");
        const isSelected = opt.value === value;
        const cls        = isSelected ? COLOR_CLASSES[colorName].sel : COLOR_CLASSES[colorName].unsel;
        return (
          <button
            key={String(opt.value) + opt.label}
            type="button"
            onClick={() => onChange(opt.value)}
            className={`px-3 py-1.5 rounded-full border transition-colors cursor-pointer ${textClass} ${cls}`}
          >
            {isClear ? "×" : opt.label}
          </button>
        );
      })}
    </div>
  );
}
